// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"Security_pageWrapper__5wliG","checkboxMargin":"Security_checkboxMargin__2Bb4t"};